module.exports = __webpack_public_path__ + "assets/img/18_171_big.2b9442f5.jpg";